var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconawesomeGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.707,
    height: 19.643,
    viewBox: "0 0 17.707 19.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-google-play",
    "data-name": "Icon awesome-google-play",
    d: "M13.291,8.991,4.822.5,15.6,6.685,13.291,8.991ZM2.612,0a1.492,1.492,0,0,0-.833,1.355V18.288a1.492,1.492,0,0,0,.833,1.355L12.458,9.82ZM18.928,8.657l-2.26-1.309L14.146,9.823,16.667,12.3l2.306-1.309a1.539,1.539,0,0,0-.046-2.333ZM4.822,19.148,15.6,12.962l-2.306-2.306Z",
    transform: "translate(-1.779)",
    fill: "#1c1c1c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeGooglePlay);
export default __webpack_public_path__ + "static/media/Icon awesome-google-play.4851ac82a0e747a6a91bc4e69bd91430.svg";
export { ForwardRef as ReactComponent };